/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '../../http/axios/index.js'

export default {
  changePassword ({commit}, item) {
    console.log('item', item)
    return new Promise((resolve, reject) => {
      axios
        .post('/cambiarClave', { 
          idUser: item.idUser,
          isbclvold: item.old_password,
          isbclvnew: item.new_password
        }, {
          headers: {
            //Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            'Content-type': 'application/json; charset=utf-8',
            'Access-Control-Allow-Origin': '*'
          }
        })
        .then(response => {
          console.log('response', response)
          if (response.data.nuOK === 0) {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
